import { useRef, useEffect } from 'react';
/**
 * React-хук, возвращающий значение свойства из предыдущего рендера.
 * @param value Значение свойства.
 */
export function usePreviousValue(value) {
    var ref = useRef();
    useEffect(function () {
        ref.current = value;
    });
    return ref.current;
}
